<!--
 * @Author: your name
 * @Date: 2020-12-07 13:52:27
 * @LastEditTime: 2021-03-25 19:50:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/designTools/index.vue
-->
<template>
  <div class="designTools">
    <div class="banner">
      <div class="pageWidth">
        <div class="content">
          <div class="title">专业的软装设计师<br />在线搭配工具</div>
          <div class="cloud" @click="handleTools">云端版</div>
        </div>
        <div class="imgBlock">
          <img src="@/assets/tools/img01.png" alt="" srcset="" />
        </div>
      </div>
    </div>
    <div class="intro-section">
      <div class="pageWidth">
        <div class="tab-group">
          <div
            class="tab-item"
            @mouseenter="enterHandle(1)"
            @mouseleave="leaveHandle(1)"
            :class="statusIndex === 1 ? 'item-active' : ''"
          >
            <img src="@/assets/tools/text1.png" alt="" />
          </div>
          <div
            class="tab-item"
            :class="statusIndex === 2 ? 'item-active' : ''"
            @mouseenter="enterHandle(2)"
            @mouseleave="leaveHandle(2)"
          >
            <img src="@/assets/tools/text2.png" alt="" />
          </div>
          <div
            class="tab-item"
            :class="statusIndex === 3 ? 'item-active' : ''"
            @mouseenter="enterHandle(3)"
            @mouseleave="leaveHandle(3)"
          >
            <img src="@/assets/tools/text3.png" alt="" />
          </div>
        </div>
        <div class="video">
          <video-player
            v-show="playerReady1 === activeIndex ? true : false"
            class="video-player-box"
            ref="videoPlayer"
            :options="playerOptions1"
            :playsinline="true"
            customEventName="customstatechangedeventname"
          ></video-player>
          <video-player
            v-show="playerReady2 === activeIndex ? true : false"
            class="video-player-box"
            ref="videoPlayer"
            :options="playerOptions2"
            :playsinline="true"
            customEventName="customstatechangedeventname"
          ></video-player>
          <video-player
            v-show="playerReady3 === activeIndex ? true : false"
            class="video-player-box"
            ref="videoPlayer"
            :options="playerOptions3"
            :playsinline="true"
            customEventName="customstatechangedeventname"
          ></video-player>
        </div>
      </div>
    </div>
    <z-login ref="zLogin" :pathFix="nextUrl"></z-login>
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { Token } from "@/utils/token.js";
export default {
  name: "",
  data() {
    return {
      nextUrl: process.env.VUE_APP_NEXT_BASIC_URL,
      activeIndex: 1,
      statusIndex: 1,
      playerReady1: 1,
      playerReady2: 2,
      playerReady3: 3,
      playerOptions1: {
        autoplay: true,
        muted: true,
        loop: true,
        width: 766,
        language: "en",
        preload: {
          auto: true,
        },
        sources: [
          {
            type: "video/mp4",
            src: "https://chain-apply.oss-cn-shanghai.aliyuncs.com/hlsc.mp4",
          },
        ],
        // aspectRatio: '4:3',
      },
      playerOptions2: {
        autoplay: true,
        muted: true,
        loop: true,
        width: 766,
        language: "en",
        preload: {
          auto: true,
        },
        sources: [
          {
            type: "video/mp4",
            src: "https://chain-apply.oss-cn-shanghai.aliyuncs.com/kt.mp4",
          },
        ],
        // aspectRatio: '4:3',
      },
      playerOptions3: {
        autoplay: true,
        muted: true,
        loop: true,
        width: 766,
        language: "en",
        preload: {
          auto: true,
        },
        sources: [
          {
            type: "video/mp4",
            src: "https://chain-apply.oss-cn-shanghai.aliyuncs.com/scqd.mp4",
          },
        ],
        // aspectRatio: '4:3',
      },
    };
  },
  components: {
    videoPlayer,
  },
  methods: {
    enterHandle(index) {
      console.log("enterHandle", index);
      this.activeIndex = index;
      this.statusIndex = index;
    },
    leaveHandle(index) {
      console.log("leaveHandle", index);
      this.statusIndex = index;
      this.activeIndex = index;
    },
    /* 视频播放 */
    playerReadied(player) {
      this.playerReady = true;
    },
    handleTools() {
      //判断是否登录
      if (Token()) {
        window.open(process.env.VUE_APP_STAGE_BASIC_URL);
      } else {
        this.$refs.zLogin.open(this.$route.fullPath);

        // this.$router.replace({
        //   path: '/sign',
        //   query: { redirect: this.$route.fullPath },
        //   hash: 'next',
        // })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.designTools {
  background: #f1f1f1;
  .pageWidth {
    display: flex;
    justify-content: space-between;
  }
  .banner {
    height: 736px;
    background: #fff;
    .content {
      .title {
        font-size: 54px;
        font-weight: 800;
        color: #000118;
        line-height: 70px;
        margin-top: 195px;
      }
      .cloud {
        width: 236px;
        height: 66px;
        background: #f04b4a;
        border-radius: 3px;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
        color: #ffffff;
        line-height: 66px;
        margin-top: 69px;
        cursor: pointer;
      }
    }
    .imgBlock {
      width: 681px;
      margin-top: 139px;
      img {
        width: 100%;
        display: block;
      }
    }
  }
  .intro-section {
    height: 736px;
    background: linear-gradient(to right, #f1f1f1 50%, #262624 50%);
    padding: 148px 0;
    position: relative;
    &::before {
      content: "";
      width: 286px;
      height: 572px;
      display: block;
      background: url("../../assets/tools/bg01.png") no-repeat;
      position: absolute;
      top: 82px;
      left: calc(50% - 1px);
      z-index: 1;
    }
    &::after {
      content: "";
      width: 45px;
      height: 252px;
      display: block;
      background: url("../../assets/tools/bg02.png") no-repeat;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      z-index: 1;
    }
    .pageWidth {
      align-items: center;
      position: relative;
      z-index: 5;
    }
    .tab-group {
      width: 380px;
      .tab-item {
        width: 380px;
        position: relative;
        img {
          width: 380px;
          display: block;
        }
        &.item-active {
          &::after {
            content: "";
            display: block;
            width: 15px;
            height: 29px;
            background: url("../../assets/tools/arrow.png") no-repeat;
            position: absolute;
            top: 41px;
            right: -15px;
          }
        }
      }
      .tab-item ~ .tab-item {
        margin-top: 36px;
      }
    }
  }
}
</style>
